import AdvertForm from 'layout/advert-form';

const MobileCreateAdverTab = () => {
    return <AdvertForm type="create" />;
};

export default MobileCreateAdverTab;
